import { render, staticRenderFns } from "./tabs-Financial.vue?vue&type=template&id=23ec575c&scoped=true&"
import script from "./tabs-Financial.vue?vue&type=script&lang=js&"
export * from "./tabs-Financial.vue?vue&type=script&lang=js&"
import style0 from "./tabs-Financial.vue?vue&type=style&index=0&id=23ec575c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec575c",
  null
  
)

export default component.exports